import React from 'react'

//components
import { BasicButton } from 'thrive-components';


const PasskeySettingsExplainer= () => {  

    return(
        <>
            <h1 className='passkey-settings-header'>
                Passkey Settings
            </h1>
                
            <span className='explainer-text'>
                Enabling Passkeys allows users to sign in with a secure, device-based credential instead of a password. This method includes built-in two-factor authentication for stronger account security. 
                <BasicButton 
                    className='link-style-button learn-more-button'
                    content={"Learn more"} 
                    ariaLabel={'Find out more about Passkeys'}
                    isLink
                    linkUrl='https://thrive.app/help-centre/passkeys'
                    openInNewTab
                />
                .
            </span>
        </>
    )
}

export default PasskeySettingsExplainer